import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id FA30BC13-BE77-44F6-BEB1-942749E019A7
 * name hospital-marker
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/hospital-marker.svg
 * tags
 * - Medical / Hospital 
 * - Navigation 
 */
export const HospitalMarkerIcon = createSvgIcon(<><path d="M12,2C15.86,2 19,5.13 19,9C19,14.25 12,22 12,22C12,22 5,14.25 5,9A7,7 0 0,1 12,2M9,6V12H11V10H13V12H15V6H13V8H11V6H9Z" /></>, 'HospitalMarkerIcon');
export default HospitalMarkerIcon